module.exports = __webpack_public_path__ + "static/media/Icons.d68f1fd6.svg";